<template>
  <div class="pc page">
    <Head :extras="extras" :logo="defaultRess.pc.logo" />

    <Banner :extras="extras" />
    <div class="container">
      <div class="item-content">
        <div class="title-box">
          <div
            class="item-title"
            v-if="extraItem.extras('listTitle.display') == '1'"
            :style="{
              color: extraItem.extras('listTitle.color'),
              fontSize: pxOrVw(extraItem.extras('listTitle.size')),
              fontWeight:
                extraItem.extras('listTitle.weight') == 'default'
                  ? '600'
                  : extraItem.extras('listTitle.weight')
            }"
          >
            {{ fileData.name }}
          </div>
          <div class="item-button">
            <div
                    class="button"
                    :style="{
                color: extraItem.extras('themecolor.bgcolor'),
                borderColor: extraItem.extras('themecolor.bgcolor')
              }"
                    v-if="extraItem.extras('downloadBtnName.display') == 1"
                    @click="onDownloadFile(fileData, fileData.downloadType)"
            >
              {{ extraItem.extras("downloadBtnName.model") || "下载文档" }}
            </div>
            <div
              class="button"
              @click="onPreview(fileData, noLogin)"
              :style="{
                color: extraItem.extras('themecolor.bgcolor'),
                borderColor: extraItem.extras('themecolor.bgcolor')
              }"
              v-if="
                (fileData.previewType == '2'  || (fileData.identity == 3  && noLogin)) &&
                  !showPreview &&
                  extraItem.extras('previewBtnName.display') == 1
              "
            >
              {{ extraItem.extras("previewBtnName.model") || "预览全部内容" }}
            </div>
          </div>
        </div>
        <!--<div class="item-summary" >-->
        <!--{{ fileData.descInfo }}-->
        <!--</div>-->
        <div class="item-foot">
          <div class="item-date" v-if="extraItem.extras('times.display') == '1'">
            {{ fileData.dateText }} <span class="icontemp chakan1"></span>
            {{ fileData.previewCount }} <span class="icontemp xiazai1"></span
            >{{ fileData.downloadCount }} <span class="icontemp wendang"></span
            >{{ fileData.sizeText }}
          </div>
        </div>
      </div>
      <div class="item-summary">
        {{ fileData.descInfo }}
      </div>

      <div
        class="content-details"
        v-if="fileData.previewType == '2' && !showPreview"
      >
        <!--<div class="desc-info">{{ fileData.descInfo }}</div>-->
        <div class="content-rich-text">
          <div class="rich-text-html" v-html="fileData.previewShow"></div>
        </div>
      </div>
      <file-preview
      @gettenantId="gettenantId"
        class="pxtovw-ignore"
        v-if="(fileData.previewType == '1' || fileData.previewType == '3') || showPreview"
        :preview-url="fileData.previewUrl"
        :fileId="fileData.fileId"
        :hideButton="true"
        :recodeInteraction="0"
        :ext-type="fileData.extType"
        :isDetail="true"
        :closable="fileData.previewType == '2'"
        :type="'pc'"
        @preview-close="showPreview = false"
      ></file-preview>
      <card :tenantId="tenantId" :webinarLive="'webinarLive'"></card>
      <Cta :obj="ctaObj" class="pxtovw-ignore"></Cta>
    </div>
  </div>
</template>

<script>
import mixin from "@/mixins/fileDetail.js";
import templateMixin from "@/mixins/template-detail.js";
import FilePreview from "@/components/FilePreview.vue";
import Head from "@/components/head";
import Banner from "@/components/banner";
import Card from '../../../stempcore/src/core/components/common/Card'
import Cta from '../../../stempcore/src/core/components/common/Cta'
export default {
  name: "PcFileDetails",
  mixins: [mixin, templateMixin],
  components: { FilePreview, Head, Banner, Card, Cta},
//  components: {Head, Banner, Card, Cta},
  data() {
    return {
      showPreview: false,
      platform: "pc",
      tenantId:''
    };
  },
  methods: {
    gettenantId(val){
      this.tenantId=val
    },
  },
};
</script>

<style lang="scss" scoped>
.pc {
  &.page {
    padding-bottom: 30px;
  }
  .header-divider {
    width: 1000px;
  }
  .header-banner-image {
    width: 100%;
  }
  .info-header {
    flex: 1;
    text-align: start;
    padding: 0 0 30px;
    .title {
      margin: 25px 0;
      font-size: 30px;
      font-weight: bold;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
    .stat-info {
      display: flex;
      margin-top: 16px;
      color: rgb(153, 153, 153);
      .date {
        margin-right: auto;
      }
      .right {
        margin-left: 28px;
      }
      i {
        padding-right: 8px;
      }
    }
    .file-action {
      margin-top: 18px;
      .action-btn {
        display: inline-block;
        width: 84px;
        height: 26px;
        line-height: 24px;
        text-align: center;
        color: $color-base;
        margin-right: 16px;
        border: solid 1px $color-base;
        border-radius: 4px;
        cursor: pointer;
        i {
          padding-right: 5px;
        }
      }
    }
  }

  .title-box {
    display: flex;
    align-items: center;
  }
  .item-button {
    display: inline-flex;
    flex-wrap: nowrap;
  }
  .desc-info {
    margin: 24px 0;
    overflow-wrap: break-word;
  }
  .rich-text {
    overflow: hidden;
  }
  .content-preview {
    height: 100vh;
  }
  .rich-text-html {
    overflow: hidden;
  }

  .item-foot {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 13px;
    height: 32px;
  }
  .item-content {
    width: 100%;
    padding-top: 20px;
    position: relative;
    color: #212121;
    &.icon {
      width: 800px;
    }
    .item-title {
      font-size: 18px;
      width: 100%;
      font-weight: 600;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .item-date {
      font-size: 12px;
      color: #AAAAAA;

      .icontemp {
        margin-left: 20px;
        font-size: 14px;
      }
    }
  }
  .button {
    display: inline-block;

    /*width: 124px;*/
    min-width: 80px;
    margin-left: 10px;
    height: 32px;
    box-sizing: border-box;
    line-height: 30px;
    text-align: center;
    border: 1px solid $blue;
    border-radius: 4px;
    color: $blue;
    font-size: 14px;
    background-color: #ffffff;
    cursor: pointer;
    max-width: 200px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    padding: 0 10px;
    .icontemp {
      font-size: 21px;
      position: relative;
      margin-right: 5px;
      top: 2px;
    }
    &:hover {
      background-color: $blue;
      color: #ffffff !important;
    }
  }
  .content-details {
    margin-top: 24px;
    padding-top: 15px;
    border-top: 1px solid #f0f0f0;
  }
  .item-summary {
    font-size: 12px;
    // opacity: 0.62;
    color: #888888;
    line-height: 24px;
    margin-top: 10px;
    word-break: break-all;
  }
}
</style>
